/**
 * Video Chat Mixin
 */
import { VIDEO_CHAT_TYPES, VIDEO_MEMBER_TYPES } from "@/helpers/constants";

export default {
  computed: {
    /**
     * Video chat types
     * @return {{MANY_TO_MANY: string, ONE_TO_ONE: string}}
     */
    videoChatTypes() {
      return VIDEO_CHAT_TYPES;
    },

    /**
     * Video member types
     * @return {Object}
     */
    videoMemberTypes() {
      return VIDEO_MEMBER_TYPES;
    },

    /**
     * Maximum number of video chat participants
     * @return {Integer}
     */
    maximumVideoChatMembers() {
      return this.$store.getters["videoChat/maximumVideoChatMembers"];
    },

    /**
     * Active video session
     */
    activeVideoSession() {
      return this.$store.state.videoChat.activeVideoSession;
    },

    /**
     * Active video chat object
     */
    activeVideoChat() {
      return this.$store.getters["videoChat/activeVideoChat"];
    },
    /**
     * Expose the config object for video chat
     */
    videoChatConfig() {
      return this.$store.getters["videoChat/videoChatConfig"];
    },

    /**
     * Get list of VideoChat Members
     * @return {Array}
     */
    videoChatMembers() {
      return this.$store.getters["videoChat/videoChatMembers"];
    },
    /**
     * Active Subscribers
     * @return {Object}
     */
    subscribers() {
      return this.$store.state.videoChat.subscribers;
    },

    /**
     * Active streams
     * @returns {[]|ReadonlyArray<MediaStream>|MediaStream[]}
     */
    streams() {
      return this.$store.state.videoChat.streams;
    },

    /**
     * Connections count
     * @return {Integer}
     */
    connectionsCount() {
      return this.$store.state.videoChat.connectionsCount;
    },

    /**
     * Allow invitations value
     */
    allowInvitations: {
      get() {
        if (this.activeVideoChat) {
          return this.activeVideoChat.allowInvitations;
        } else {
          let videoChat = this.$store.getters["videoChat/videoChat"](this.sentVideoCallInvites[0].groupUUID);
          return videoChat ? videoChat.allowInvitations : null;
        }
      },
      async set(value) {
        await this.$store.dispatch("videoChat/updateVideoChat", {
          videoChatUUID: this.activeVideoChat ? this.activeVideoChat.groupUUID : this.sentVideoCallInvites[0].groupUUID,
          data: {
            allowInvitations: value
          }
        });
      }
    }
  },
  methods: {
    /**
     * Leave video chat
     */
    async leaveVideoCall() {
      await this.$store.dispatch("videoChat/leaveVideoCall");
    }
  }
};
